import { c as _c } from "react/compiler-runtime";
import DotLoader, { Spinner } from "@/components/dotLoader/DotLoader";
import { MEMES_MINT_PRICE } from "@/constants/constants";
import type { SubscriptionDetails } from "@/generated/models/SubscriptionDetails";
import { numberWithCommas } from "@/helpers/Helpers";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import EthereumIcon from "../utils/icons/EthereumIcon";
export default function UserPageSubscriptionsBalance(props) {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h5 className="no-wrap mb-0">Current Balance</h5>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = props.show_refresh && <>{props.fetching ? <Spinner /> : <FontAwesomeIcon icon={faRefresh} onClick={() => {
        props.refresh();
      }} style={{
        height: "24px",
        cursor: "pointer"
      }} aria-label="Refresh balance" tabIndex={0} role="button" />}</>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Row className="pb-2"><Col className="d-flex align-items-center gap-2">{t0}{t1}</Col></Row>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.details || $[6] !== props.fetching) {
    t3 = <Row className="pt-1"><Col>{props.fetching ? <DotLoader /> : <span className="d-flex align-items-center gap-3"><span className="d-flex align-items-center gap-2"><div className="d-flex align-items-center gap-1"><b>{props.details?.balance ? numberWithCommas(Math.round(props.details.balance * 1000000) / 1000000) : 0}</b><div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><EthereumIcon /></div></div>{props.details && props.details.balance > 0 && <>({(props.details.balance / MEMES_MINT_PRICE).toLocaleString(undefined, {
                maximumFractionDigits: 0
              })}{" "}cards)</>}</span></span>}</Col></Row>;
    $[5] = props.details;
    $[6] = props.fetching;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Container className="no-padding">{t2}{t3}</Container>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}